module.exports = __webpack_public_path__ + "img/bound.ce7b7dd9.png";